import React from 'react'
import { Icon } from '../../../atoms'

const AccordionIcons = () => (
  <>
    <div className='money-voice-top-picks__accordion__chevron money-voice-top-picks__accordion__chevron__down'>
      <Icon glyph={'arrow-down'} size={24} color={'#924A8B'} />
    </div>
    <div className='money-voice-top-picks__accordion__chevron money-voice-top-picks__accordion__chevron__up'>
      <Icon glyph={'arrow-up'} size={24} color={'#924A8B'} />
    </div>
  </>
)

export const MoneyVoiceAccordion = ({ title, dataTrackingObject, open = false, children }) => (
  <details className='money-voice-top-picks__accordion' open={open}>
    <summary
      className='money-voice-top-picks__accordion__title'
      data-click-accordion-tracking={JSON.stringify(dataTrackingObject)}
    >
      <AccordionIcons />
      {title}
    </summary>
    <div className='money-voice-top-picks__accordion__content'>{children}</div>
  </details>
)
